<template>
	<div>
		<CModal title="Paiements de la commande" size="lg" :show.sync="showModal">
			<template v-if="showModal">
				<GDataTableRemote
					class="mt-3"
					ref="mainTable"
					:remote-url="queryUrl"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #method="{ item }">
						<td>
							{{ paymentTranslation[item.method] }}
						</td>
					</template>
					<template #status="{ item }">
						<td>
							<CBadge v-if="item.status === 0" color="danger">Erreur</CBadge>
							<CBadge v-else-if="item.status === 1" color="success">Succès</CBadge>
							<CBadge v-else color="danger">Erreur inconnue</CBadge>
						</td>
					</template>
				</GDataTableRemote>
			</template>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GDataTableRemote from '../ghostlexly-components/GDataTableRemote';

	export default {
		components: { GDataTableRemote },
		data() {
			return {
				fields: [
					{ key: 'transactionid', label: 'Numéro de transaction' },
					{ key: 'info', label: "Code d'erreur" },
					{ key: 'amount', label: 'montant' },
					{ key: 'status', label: 'Statut' },
					{ key: 'method', label: 'Méthode' },
					{ key: 'additionalInfo', label: 'Informations complémentaires' },
				],
				paymentTranslation: {
					'payment.credit_card': 'Carte bancaire',
					'payment.older_backoffice': 'Ancien backoffice',
					'payment.tpe': 'Carte bancaire (TPE)',
					'payment.paypal': 'Paypal',
					'payment.cash': 'Espèces',
					'payment.check': 'Chèque',
					'payment.bank_transfer': 'Virement',
					'payment.credit_note': 'Avoir',
					'payment.free': 'Gratuit',
					'payment.gift': 'Cadeau',
					'payment.reshipment': 'Réexpédition',
					'payment.dealer': 'Revendeur',
				},
				showModal: false,
				queryUrl: '',
			};
		},
	};
</script>
